import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a888b562&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a888b562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a888b562",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Video.vue').default,ImageLoading: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ImageLoading.vue').default,BreadCrumb: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/BreadCrumb.vue').default,ShareList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ShareList.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default,InquiryForm: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InquiryForm.vue').default,LikeList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/LikeList.vue').default})
